(function () {
    'use strict';

    angular
        .module('travelControllers')
        .controller('TravelGovernanceProcessListController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'fiscalYears', 'governanceProcess', 'govProcessType'];

    function Controller($scope, $state, topBarService, fiscalYears, governanceProcess, govProcessType) {
        topBarService.setTitleAndIcon('Travel Governance Process Management', 'fa fa-plane');

        if (governanceProcess && governanceProcess.GovernanceProcessID) {
            $scope.governanceProcess = governanceProcess;
        }

        $scope.govProcessType = govProcessType;
        
        $scope.goHome = function () {
            $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
        };

        $scope.goToGovernanceProcess = function () {
            $state.go('travel.governanceProcessEdit', {
                GovernanceProcessID: $scope.governanceProcess.GovernanceProcessID
            });
        };

        $scope.goToAddGovernanceProcess = function () {
            $state.go('travel.governanceProcessAdd');
        };
    }
})();   